import CountryCode from './countryCode.json';

// Detect the variable existence and empty value
export const isNotNull = (value) => {
    if (value !== undefined && value !== null && value) {
      return true;
    }
    return false;
  }

// Remove Country Code 
export const removeCountryCode = (phone) => {
    const country = CountryCode.find((item) => phone.includes(item.code));
    if (country) {
      return phone.replace(country.code, '');
    }
    return phone;
  }